import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAppSelector } from "./Redux/app/hooks";
import AuthRoutes from "./Routes/AuthRoutes";
import PrivateRoutes from "./Routes/PrivateRoutes";

const Router = () => {
  const { currentUser } = useAppSelector((state) => state.user);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={!currentUser ? <AuthRoutes /> : <PrivateRoutes />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
